import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { Router } from '@angular/router';
import {
  ComponentDataSourceService,
  DataSourceFunction,
} from '../../component-data-source.service';
import { LoadDataParams } from '../../../../interfaces/DataSource/DataSourceParams.interface';
import { environment } from '../../../../environment/environment';

const UUID_REGEX =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

function resolveEventGuid(
  service: ComponentDataSourceService,
  params?: LoadDataParams
): string | null {
  const fromQuery =
    params?.queryParams?.['eventGuid'] ??
    params?.queryParams?.['guid'] ??
    params?.queryParams?.['event_guid'];
  if (typeof fromQuery === 'string' && UUID_REGEX.test(fromQuery)) {
    return fromQuery;
  }
  const router = service.injector.get(Router);
  const pathSegments = (router.url || '').split('?')[0].split('/');
  const found = pathSegments.find((segment) => UUID_REGEX.test(segment));
  return found ?? null;
}

export function add_event_materials(
  service: ComponentDataSourceService
): DataSourceFunction {
  return {
    name: 'Event Materials',
    description: 'Lists all materials requested for the event',
    execute: (params?: LoadDataParams): Observable<
      { material_name: string; quantity: number }[]
    > => {
      const guid = resolveEventGuid(service, params);
      if (!guid) {
        return of([]);
      }
      return service.http
        .get<{ materials: { name: string; quantity: number }[] }>(
          `${environment.apiUrl}/events/${guid}/materials`
        )
        .pipe(
          map((res) =>
            (res.materials || []).map((m) => ({
              material_name: m.name,
              quantity: m.quantity,
            }))
          ),
          catchError(() => of([]))
        );
    },
    settings: {
      columns: [
        { key: 'material_name', header: 'Materiale', type: 'text' },
        { key: 'quantity', header: 'Antal', type: 'number' },
      ],
      pageable: true,
      sortable: true,
      rowHover: true,
      defaultSortColumn: 'material_name',
      defaultSortDirection: 'asc',
    },
  };
}
